import { Component, Inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MatSliderChange, MAT_DIALOG_DATA } from '@angular/material';

@Component({
	selector: 'app-understand',
	templateUrl: './understand.component.html',
	styleUrls: ['./understand.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixUnderstandComponent implements OnInit {

	constructor(
		public dialogRef: MatDialogRef<PixUnderstandComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
	}

	ngOnInit(): void {
	}

	onClose(): void {
		this.dialogRef.close();
	}

	onConfirm(): void {
		this.dialogRef.close(true);
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/limits/understand/understand.component.ts